var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-credits-list-item-copy",class:("c-credits-list-item-copy--" + _vm.itemIndex)},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.copy)}})])}
var staticRenderFns = []

export { render, staticRenderFns }